'use client'; // Error boundaries must be Client Components

import NextError from 'next/error';
import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
	const posthog = usePostHog();

	useEffect(() => {
		posthog.captureException(error);
	}, [error, posthog]);

	return (
		// global-error must include html and body tags
		<html>
			<body>
				{/* `NextError` is the default Next.js error page component */}
				<NextError statusCode={0} />
			</body>
		</html>
	);
}
